type Props = {
  headerItems?: React.ReactNode;
  primaryItems: React.ReactNode;
  secondaryItems: React.ReactNode;
};

export const DashboardLayout = ({ headerItems, primaryItems, secondaryItems }: Props): JSX.Element => {
  return (
    <div className="grid xl-d:grid-cols-[minmax(0,_1fr)] xl:grid-cols-[minmax(0,_1fr)_minmax(0,_1fr)_minmax(392px,392px)] gap-24">
      {headerItems && <div className="empty:hidden col-span-full space-y-24">{headerItems}</div>}
      <div className="xl:col-span-2 space-y-24">{primaryItems}</div>
      <div className="space-y-24">{secondaryItems}</div>
    </div>
  );
};
